import styled from 'styled-components'

export const LeaderBoardWrapper = styled.div`
  margin: 6rem 20px 0 20px;
`

export const LeaderBoardItemWrapper = styled.div``

export const LeaderBoardItem = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.07);
  width: 100%;
  height: 55px;
  border-radius: 25px;
  /* padding: 0 10px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`

export const LeftContent = styled.div`
  display: flex;
  width: 140px;
  justify-content: space-between;
  padding-left: 10px;
  .name {
    display: flex;
    align-items: center;
    font-size: ${({ theme }) => theme.fontSize.x6};
    color: ${({ theme }) => theme.colors.navyBlue};
  }
  .icon {
    /* background: rgba(0, 196, 140, 0.1); */
    overflow: hidden;
    /* border: 1px solid #00c48c; */
    color: #00c48c;
    padding-left: 8px;
    width: 24px;
    height: 24px;
  }
`

export const RightContent = styled.div`
  padding-right: 10px;
`
